import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=385a96a4&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=385a96a4&prod&lang=scss&scoped=true"
import style1 from "./ProductView.vue?vue&type=style&index=1&id=385a96a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385a96a4",
  null
  
)

export default component.exports